import { Breadcrumb } from "@/components/breadcrumb";
import { Button, Container, VStack } from "@chakra-ui/react";
import { ArrowLeft } from "lucide-react";

export const PageLayout = ({
  children,
  breadcrumb,
  backButtonText,
  onBackAction,
}: {
  children: React.ReactNode;
  breadcrumb?: { items: { label: string; href: string }[]; current: string };
  backButtonText?: string;
  onBackAction?: () => void;
}) => {
  return (
    <Container>
      <VStack gap={{ base: 0, lg: 4 }} w="full" align="start">
        {onBackAction && (
          <Button onClick={onBackAction} variant="ghost">
            <ArrowLeft />
            {backButtonText}
          </Button>
        )}
        {breadcrumb && (
          <Breadcrumb items={breadcrumb.items} current={breadcrumb.current} />
        )}
        <VStack w="full" flex={1}>
          {children}
        </VStack>
      </VStack>
    </Container>
  );
};
